import type { OperatorAttachedFile } from "@lib/agenticAi/types";

import type { AttachedFileParam } from "./types";

/**
 * Maps attached files to the snake_case `attached_files` request parameter
 * shared by both AI agent provider endpoints. Empty in, empty out; the backend
 * treats an empty `attached_files` the same as an absent one.
 */
export const serializeAttachedFiles = (attachedFiles: OperatorAttachedFile[]): AttachedFileParam[] => {
  return attachedFiles.map(({ url, fileName, mimeType, context }) => ({
    url,
    file_name: fileName,
    mime_type: mimeType,
    context,
  }));
};
